/** Infobulle d’obligation — jamais le tooltip natif du navigateur. */
export function MissTip({ text = "À remplir pour enregistrer." }: { text?: string }) {
  return (
    <span className="fx-miss-tip" role="tooltip">
      {text}
    </span>
  );
}
